(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('de')) return;

  const opening =
    'Mindestens ein Artikel in deinem Warenkorb wird regelmäßig geliefert. Mit dem Fortfahren stimmst du der ';
  const closing =
    ' zu und autorisierst JustBe, deine Zahlungsmethode zu den angegebenen Preisen und Lieferintervallen zu belasten, bis du das Abonnement – soweit zulässig – kündigst.';

  const fixConsentCopy = (root = document) => {
    const consents = [];
    if (root.nodeType === 1 && root.matches?.('#shopify-buyer-consent')) consents.push(root);
    root.querySelectorAll?.('#shopify-buyer-consent').forEach((element) => consents.push(element));

    consents.forEach((consent) => {
      if (consent.textContent.trim().startsWith('Mindestens ein Artikel')) return;

      const policy = consent.querySelector('#shopify-subscription-policy-button');
      if (!policy) return;

      consent.replaceChildren(document.createTextNode(opening), policy, document.createTextNode(closing));
      consent.dataset.justbeCopyFixed = 'true';
    });
  };

  const start = () => {
    fixConsentCopy();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) fixConsentCopy(node);
        });
        if (mutation.target?.closest?.('#shopify-buyer-consent')) fixConsentCopy(document);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
